export default __webpack_public_path__ + "static/media/emotion-xl@3x.763ef84e.png";